import comp from "./RenameModal";
export default comp;
